import React, { Component } from 'react';
import AsideNavbar from '../components/navbars/AsideNavbar';
import Navbars from '../components/navbars/Navbars';
import DoubtList from '../components/Doubts/DoubtList';
import CreateDoubtForm from '../components/Doubts/CreateDoubtForm';
import DoubtTracking from '../components/Doubts/DoubtTracking';
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import { DOUBT_DESK_CSS, getStampClass } from '../components/Doubts/doubtDeskStyles';
import { parseDoubtTime } from '../components/Doubts/doubtHelpers';
import ProfileDateBlock from '../components/student_profile/ProfileDateBlock';
import moment from 'moment';

const GET_DOUBTS = gql`
  query($mobile: String!) {
    getDoubts(mobile: $mobile) {
      id
      title
      description
      image_path
      doubt_status
      raised_time
      timestamp
      unseen_count
      subject_name
      chapter_name
    }
  }
`;

const GET_DOUBT_STATUSES = gql`
  query {
    getDoubtStatuses {
      id
      status
      estatus
    }
  }
`;


class Doubts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: Cookies.get("toggle") || "wrapper",
            selectedDoubt: null,
            showCreateDrawer: false,
            statusFilter: "all",
            selectedSubjects: [],
            subjectsTouched: false,
            rangeStart: null,
            rangeEnd: null,
            rangeTouched: false,
            rangeKey: 0
        };
    }

    componentDidMount() {
        this.syncSubjectSelection();
        this.initDateRange();
    }

    // The picker always shows a range, so the default one has to genuinely cover
    // every doubt: from the oldest doubt raised up to today.
    defaultRange = () => {
        const doubts = this.props.getDoubts && this.props.getDoubts.getDoubts ? this.props.getDoubts.getDoubts : [];
        const times = doubts
            .map(d => parseDoubtTime(d.raised_time || d.timestamp))
            .filter(Boolean);

        const start = times.length ? moment.min(times).startOf('day') : moment().subtract(1, 'year').startOf('day');
        return { start: start, end: moment().endOf('day') };
    }

    initDateRange = () => {
        if (this.state.rangeTouched || this.state.rangeStart) return;

        const doubts = this.props.getDoubts && this.props.getDoubts.getDoubts ? this.props.getDoubts.getDoubts : [];
        if (!doubts.length) return;

        const range = this.defaultRange();
        this.setState({ rangeStart: range.start, rangeEnd: range.end });
    }

    resetDateRange = () => {
        const range = this.defaultRange();
        this.setState({
            rangeStart: range.start,
            rangeEnd: range.end,
            rangeTouched: false,
            rangeKey: this.state.rangeKey + 1
        });
    }

    // Every subject starts ticked, and stays in step with the register until
    // the student picks their own selection.
    syncSubjectSelection = () => {
        if (this.state.subjectsTouched) return;

        const doubts = this.props.getDoubts && this.props.getDoubts.getDoubts ? this.props.getDoubts.getDoubts : [];
        const subjects = Array.from(new Set(doubts.map(d => d.subject_name).filter(Boolean)));
        const current = this.state.selectedSubjects;
        const unchanged = subjects.length === current.length && subjects.every(s => current.indexOf(s) !== -1);

        if (!unchanged) {
            this.setState({ selectedSubjects: subjects });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this.syncSubjectSelection();
        this.initDateRange();

        if (this.state.selectedDoubt) {
            const prevDoubts = prevProps.getDoubts && prevProps.getDoubts.getDoubts ? prevProps.getDoubts.getDoubts : [];
            const currDoubts = this.props.getDoubts && this.props.getDoubts.getDoubts ? this.props.getDoubts.getDoubts : [];
            if (prevDoubts !== currDoubts) {
                const updatedDoubt = currDoubts.find(d => d.id.toString() === this.state.selectedDoubt.id.toString());
                if (updatedDoubt && JSON.stringify(updatedDoubt) !== JSON.stringify(this.state.selectedDoubt)) {
                    this.setState({ selectedDoubt: updatedDoubt });
                }
            }
        }
    }

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    handleDoubtCreated = () => {
        this.setState({ showCreateDrawer: false, statusFilter: "all" });
        if (this.props.getDoubts) {
            this.props.getDoubts.refetch();
        }
    }

    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        const { getDoubts, getDoubtStatuses } = this.props;
        const loading = (getDoubts && getDoubts.loading) || (getDoubtStatuses && getDoubtStatuses.loading);
        const error = (getDoubts && getDoubts.error) || (getDoubtStatuses && getDoubtStatuses.error);

        if (error) {
            alert("Error fetching doubts: " + error.message);
            return null;
        }

        const doubts = getDoubts && getDoubts.getDoubts ? getDoubts.getDoubts : [];
        const statusList = getDoubtStatuses && getDoubtStatuses.getDoubtStatuses ? getDoubtStatuses.getDoubtStatuses : [];

        const statusMap = statusList.reduce((acc, s) => {
            acc[s.id] = {
                name: s.status,
            };
            return acc;
        }, {});

        const getStatusName = (id) => {
            if (statusMap[id]) return statusMap[id].name;
            if (id == 1) return "Open";
            if (id == 2) return "In Progress";
            if (id == 3) return "Closed";
            return "Unknown";
        };

        const getStatusColor = (id) => {
            if (id == 3) return "#00c596"; // closed
            if (id == 2) return "#36a1f5"; // in progress
            return "#feb019";              // open
        };

        const statusOptions = [1, 2, 3].map(id => ({ id: id.toString(), name: getStatusName(id) }));

        // Subject filter options, derived from the student's own register
        const subjects = Array.from(new Set(doubts.map(d => d.subject_name).filter(Boolean)));

        // no subject picked = every subject
        const subjectDoubts = this.state.selectedSubjects.length === 0
            ? doubts
            : doubts.filter(d => this.state.selectedSubjects.indexOf(d.subject_name) !== -1);

        return (
            <div className={Cookies.get("toggle") || "wrapper"}>
                <style>{DOUBT_DESK_CSS}</style>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper dd-main">
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper dd-fit">
                        <div className="dd-page">
                            <div className="doubt-desk">
                                {/* ---------- top bar ---------- */}
                                <header className="dd-topbar">
                                    <div className="dd-brand">
                                        <div className="dd-brand-mark">RE</div>
                                        <div className="dd-brand-text">
                                            <h1>Doubt Desk</h1>
                                            <span>Subject Query Register</span>
                                        </div>
                                    </div>
                                    <div className="dd-topbar-actions">
                                        <div className="dd-date-range">
                                            <label>Date range</label>
                                            <ProfileDateBlock
                                                key={this.state.rangeKey}
                                                start={this.state.rangeStart}
                                                end={this.state.rangeEnd}
                                                leftMode={true}
                                                applyCallback={(start, end) => this.setState({
                                                    rangeStart: start,
                                                    rangeEnd: end,
                                                    rangeTouched: true,
                                                    selectedDoubt: null
                                                })}
                                            />
                                        </div>

                                        <button
                                            className="dd-new-doubt-btn"
                                            onClick={() => this.setState({ showCreateDrawer: true })}
                                        >
                                            + Ask a new doubt
                                        </button>
                                    </div>
                                </header>

                                {/* ---------- workspace ---------- */}
                                {loading && doubts.length === 0 ? (
                                    <div className="dd-workspace" style={{ background: '#ffffff', alignItems: 'center', justifyContent: 'center' }}>
                                        <PreloaderTwo />
                                    </div>
                                ) : (
                                    <main className={`dd-workspace ${this.state.selectedDoubt ? 'dd-has-selection' : ''}`}>
                                        {/* register / thread list */}
                                        <section className="dd-threads">
                                            <DoubtList
                                                doubts={subjectDoubts}
                                                subjects={subjects}
                                                selectedSubjects={this.state.selectedSubjects}
                                                onSubjectsChange={(picked) => this.setState({
                                                    selectedSubjects: picked,
                                                    subjectsTouched: true,
                                                    selectedDoubt: null
                                                })}
                                                statusFilter={this.state.statusFilter}
                                                rangeStart={this.state.rangeStart}
                                                rangeEnd={this.state.rangeEnd}
                                                dateNarrowed={this.state.rangeTouched}
                                                onResetDates={this.resetDateRange}
                                                statusOptions={statusOptions}
                                                onStatusFilterChange={(filter) => this.setState({ statusFilter: filter })}
                                                selectedDoubt={this.state.selectedDoubt}
                                                onSelectDoubt={(doubt) => this.setState({ selectedDoubt: doubt })}
                                                onSwitchToCreate={() => this.setState({ showCreateDrawer: true })}
                                                refetchDoubts={() => this.props.getDoubts.refetch()}
                                                getStatusName={getStatusName}
                                                getStampClass={getStampClass}
                                            />
                                        </section>

                                        {/* conversation */}
                                        <section className="dd-chat">
                                            {this.state.selectedDoubt ? (
                                                <DoubtTracking
                                                    key={this.state.selectedDoubt.id}
                                                    doubt={this.state.selectedDoubt}
                                                    onClose={() => this.setState({ selectedDoubt: null })}
                                                    refetchDoubts={() => this.props.getDoubts.refetch()}
                                                    getStatusName={getStatusName}
                                                    getStatusColor={getStatusColor}
                                                    getStampClass={getStampClass}
                                                />
                                            ) : (
                                                <div className="dd-chat-empty">
                                                    <div className="dd-chat-empty-card">
                                                        <div className="dd-chat-empty-icon">
                                                            <i className="fas fa-comments" />
                                                        </div>
                                                        <h4>Your Doubts</h4>
                                                        <p>Select a doubt from the left to start a conversation.</p>
                                                    </div>
                                                </div>
                                            )}
                                        </section>
                                    </main>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Create Doubt Form Slider Drawer */}
                <div
                    className={`drawer-overlay ${this.state.showCreateDrawer ? 'open' : ''}`}
                    onClick={() => this.setState({ showCreateDrawer: false })}
                />
                <div className={`create-doubt-drawer ${this.state.showCreateDrawer ? 'open' : ''}`}>
                    <div className="drawer-header">
                        <h5>Log a new doubt</h5>
                        <button
                            className="drawer-close-btn"
                            onClick={() => this.setState({ showCreateDrawer: false })}
                        >
                            &times;
                        </button>
                    </div>
                    <div className="drawer-body">
                        <CreateDoubtForm
                            onDoubtCreated={this.handleDoubtCreated}
                            onCancel={() => this.setState({ showCreateDrawer: false })}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default compose(
    graphql(GET_DOUBTS, {
        options: props => ({
            variables: {
                mobile: Cookies.get("mobile") || ""
            },
            fetchPolicy: "cache-and-network"
        }), name: "getDoubts"
    }),
    graphql(GET_DOUBT_STATUSES, {
        name: "getDoubtStatuses"
    })
)(Doubts);

